<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="title-heading d-flex justify-content-between">
          <h1>{{ $static('multisend-i.title', 'Редагування розсилки') }}</h1>
        </div>
        <div class="panel panel-bordered panel-bg mailing-panel">
          <div class="row">
            <div class="col-12">
              <div class="mailing-holder mailing-panel d-flex justify-content-between">

                <div class="mailing-start-message">
                  <div class="default-link">
                    <a href="javascript:void(0)" @click="goBack">
                      <span class="icon icon-left"></span>
                      <span class="text">{{ $static('multisend-i.back', 'Назад до розсилок') }}</span>
                    </a>
                  </div>
                  <div class="form-group mb-2" :class="{ 'error': errors['name'] }" @click="delError('name')">
                    <label class="custom-label">{{ $static('multisend-i.name', 'Введіть назву інформаційної розсилки:')
                      }}</label>
                    <input type="text" class="form-control custom-input"
                      :placeholder="$static('multisend-i.name-p', 'Привіт, мене звуть ChatBotDev')" v-model="post.name">
                    <p class="help-text" v-for="(err, key) in errors['name']" :key="key">{{ err }}</p>
                  </div>
                  <div class="custom-label" style="color:#565656; margin-top: 25px; font-style: italic">{{
                    $static(
                      'multisend-i.t222',
                      'Рекомендований розмір 1080 x 1080 px. Крім того, радимо оптимізувати зображення'
                    )
                  }}
                  </div>
                  <div class="files-uploader default-files-uploader" style="margin-bottom:20px;">
                    <div class="files-uploader-holder"
                      v-if="!post.template.settings.images || post.template.settings.images.length === 0"
                      @click="openFileManager">
                      <span class="icon icon-cloud-upload"></span>
                      <p>{{ $static('multisend-i.up1', 'Завантажте свої зображення сюди') }}</p>
                      <span>{{ $static('multisend-i.up2', 'Зображення повинні мати розширення .png або .jpg') }}</span>
                    </div>
                    <div class="uploader-previews" @click="openFileManager" v-else>
                      <div class="image bg" v-for="(image, index) in post.template.settings.images"
                        :style="{ backgroundImage: $filters.backgroundImage(image.url) }">
                        <a href="#" class="btn-icon btn-remove btn-small" @click.prevent.stop="delImage(index)">
                          <span class="icon icon-trash-filled"></span>
                        </a>
                        <!--                        <a href="javascript:void(0)" class="btn-icon  btn-small" @click.prevent.stop="moveImage(index, -1)"-->
                        <!--                           style="bottom: inherit;top: 3px;left: 3px;">-->
                        <!--                          <span class="icon icon-left"></span>-->
                        <!--                        </a>-->
                        <!--                        <a href="javascript:void(0)" class="btn-icon  btn-small" @click.prevent.stop="moveImage(index, 1)"-->
                        <!--                           style="bottom: inherit;top: 3px;right: 3px;">-->
                        <!--                          <span class="icon icon-right"></span>-->
                        <!--                        </a>-->
                      </div>
                    </div>

                    <div class="image-placeholder" @click="openFileManager" v-if="post.template &&
                      post.template.settings &&
                      post.template.settings.images &&
                      post.template.settings.images.length">
                      <div class="text">1080 x 1080</div>
                    </div>
                  </div>
                  <div class="form-group" @click="delError('template')" :class="{ 'error': errors['name'] }">
                    <div class="custom-editor-holder">
                      <textarea class="form-control custom-input" :placeholder="placeholder"
                        v-model="post.template.src"></textarea>

                      <!--                    <editor :small="true" v-model="post.template.src"></editor>-->
                    </div>
                    <p class="help-text" v-for="(err, key) in errors['template']" :key="key">{{ err }}</p>
                  </div>
                  <!--                  <div class="custom-editor-holder">-->
                  <!--                    <editor v-model="post.template.src" :small="true"></editor>-->
                  <!--                  </div>-->
                  <!--                  <textarea rows="10" class="form-control custom-input html-block" v-model="post.template.html"></textarea>-->
                </div>
                <div class="mailing-options-side">
                  <div class="panel">
                    <div class="row">
                      <div class="col">
                        <div class="form-group">
                          <label class="custom-label">{{ $static('multisend-i.segment', 'Сегмент') }}</label>
                          <div class="custom-input-group">
                            <select v-model="post.info.segment" class="form-control custom-input">
                              <option :value="undefined">{{ $static('multisend-i.all', 'Всі') }}</option>
                              <option value="busked">{{ $static('multisend-i.buskeds', 'Покинутий кошик') }}</option>
                            </select>
                          </div>
                        </div>

                        <div class="form-group" v-if="post.info.segment === 'busked'">
                          <label class="custom-label">{{
                            $static('multisend-i.busked_update', 'Термін вичікування кошика (години)')
                          }}</label>
                          <div class="custom-input-group">
                            <input type="text" class="form-control custom-input"
                              v-model.number="post.info.busked_update">
                          </div>
                        </div>

                        <hr>

                        <div class="form-group">
                          <label class="custom-label">{{ $static('multisend-i.callback', 'Після відправки') }}</label>
                          <div class="custom-input-group">
                            <select v-model="post.info.callback" class="form-control custom-input">
                              <option :value="undefined">{{ $static('multisend-i.no', 'Нічого не робити') }}</option>
                              <option value="repeat">{{ $static('multisend-i.repeat', 'Запланувати нову відправку') }}
                              </option>
                            </select>
                          </div>
                        </div>

                        <div class="form-group" v-if="post.info.callback">
                          <label class="custom-label">
                            {{ $static('multisend-i.delay', 'Через скількі (днів) зробити повторну відправку')
                            }}</label>
                          <div class="custom-input-group">
                            <input type="text" class="form-control custom-input" v-model.number="post.info.delay">
                          </div>
                        </div>

                        <hr>
                      </div>
                      <div class="col">
                        <div class="form-group">
                          <label class="custom-label">{{ $static('multisend-i.date', 'Оберіть дату відправки:')
                            }}</label>
                          <div class="custom-input-group">
                            <v-date-picker v-model="post.timestamp" mode="dateTime" is24hr :min-date='new Date()'
                              is-expanded :class="{ 'no-time-error': errors.noTime }" class="time"
                              :locale="datePickerLocale" />
                          </div>
                        </div>

                        <div
                          class="mailing-result-panel panel panel-bordered d-flex align-items-center justify-content-center">
                          <div class="result-holder text-center">
                            <h4 class="">{{ $static('multisend-i.users', 'Всього користувачів:') }}</h4>
                            <div class="value">
                              <span class="text">{{ tgInfo.count }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- !Ряды кнопок -->
              <div class="button-rows panel panel-bordered " v-for="(btnRow, btnRowIndex) in buttons" :key="btnRowIndex"
                @removeRow="delButtonRow(btnRowIndex)">
                <template v-for="(btn, btnIndex) in btnRow" :key="btnIndex">
                  <MessageButton
                    v-if="errors['button'] && errors['button'][btnRowIndex] && errors['button'][btnRowIndex][btnIndex]"
                    :item="btn" :errors="errors['button'][btnRowIndex][btnIndex]"
                    @remove="delButton(btnRowIndex, btnIndex)"
                    @update:itemType="(payload) => changeBtnType(payload, btnIndex, btnRowIndex)"
                    @resetBtnError="(type) => { handleBtnErrorReset(type, btnRowIndex, btnIndex) }" />
                </template>
                <div class="btns mt-2 d-flex">
                  <button class=" default-btn btn-with-icon btn-white btn-green" @click="addButton(btnRowIndex)"
                    style="margin-right: 15px">
                    <span class="text">{{ $static('multisend-i.add-btn', 'Додати кнопку') }}</span>
                    <span class="icon icon-add"></span>
                  </button>
                  <button class=" default-btn btn-with-icon btn-white btn-remove" @click="delButtonRow(btnRowIndex)">
                    <span class="text">{{ $static('multisend-i.del-btn-row', 'Видалити ряд кнопок') }}</span>
                    <span class="icon icon-trash"></span>
                  </button>
                </div>
              </div>
              <button class=" default-btn btn-with-icon btn-white btn-green mt-2" @click="addButtonRow">
                <span class="text">{{ $static('multisend-i.add-btn-row', 'Додати ряд кнопок') }}</span>
                <span class="icon icon-add"></span>
              </button>

              <div class="button-panel">
                <button class=" default-btn btn-green" style="margin-right:15px;" @click="selfCheck" v-if="ownerid">
                  <span class="text">{{ $static('multisend-i.b1', 'Надіслати собі') }}</span>
                </button>
                <p v-else>
                  {{ $static('multisend-i.self1', 'Щоб відправити собі повідомлення.') }}

                  <router-link :to="{ name: 'SettingsBasic' }" class=" default-btn transparent-btn"
                    style="padding-left:10px;text-decoration: underline !important;">
                    {{ $static('multisend-i.self2', 'Вкажіть ваш ID та токен Бота у налаштуваннях') }}
                  </router-link>
                </p>
                <button class=" default-btn btn-accent" @click="save">
                  <span class="text">{{ $static('multisend-i.b2', 'Зберегти зміни') }}</span>
                </button>
                <button class=" default-btn transparent-btn" @click="goBack">
                  <span class="text">{{ $static('multisend-i.b3', 'Скасувати') }}</span>
                </button>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import Editor from '../components/TelegramEditor';
import MessageButton from './MessageButton';
// import MessageTemplateEditor from '../components/MessageTemplateEditor';

let tomorow = new Date().getTime();
tomorow = new Date(tomorow - tomorow % (86400 * 1000) + (86400 * 1000) + (43200 * 1000));

export default {
  name: 'MultisendItem',
  components: { MessageButton, Editor },
  props: ['id', 'copy', 'template'],
  data() {
    return {
      errors: { button: [] },
      noButtonErrors: true,
      saveID: undefined,
      post: {
        name: '',
        status: 'new',
        info: {
          segment: undefined,
          busked_update: 0,
          callback: undefined,
          delay: 1
        },
        template: {
          html: '',
          src: '',
          settings: {
            images: [],
            button: []
          }
        },

        timestamp: undefined
      },
      tgInfo: {},
      isTestMessageSent: false,
    }
  },
  async mounted() {
    if (this.template) {
      let temp = JSON.parse(this.template)
      this.post = Object.assign(this.post, temp)
      if (temp.timestamp) {
        setTimeout(() => {
          this.post.timestamp = new Date(temp.timestamp + 1)
        }, 300)
      }
    }

    await this.getTelegramInfo();
    await this.fetch();
    // Инициализируем массив `errors['button']` с той же структурой, что и `this.post.template.settings.button`
    this.errors['button'] = this.buttons.map(subArray =>
      subArray.map(button => ({}))
    );
  },

  computed: {
    placeholder() {
      return this.$static('edtrr.placeholder', 'Введите текс сюда...')
    },
    settings() {
      return this.$store.getters.settings
    },
    buttons() {
      return this.post.template &&
        this.post.template.settings &&
        this.post.template.settings.button &&
        Array.isArray(this.post.template.settings.button) ? this.post.template.settings.button : []
    },
    ownerid() {
      return this.settings && this.settings.env && this.settings.env.OWNER_ID && this.settings.env.TELEGRAM_BOT_TOKEN
    },
    datePickerLocale() {
      const currentLang = localStorage.getItem('$lang');
      console.log(currentLang)
      if (currentLang && currentLang !== "" && currentLang !== "ua") {
        return currentLang
      }
      return "uk"
    }
  },

  methods: {
    addButtonRow() {
      if (this.buttons?.length) {
        this.errors["button"].push([{ textError: false, linkError: false, linkFormatError: false }])
        this.post.template.settings.button.push([{ type: 'webApp', text: '', link: '' }])
      } else {
        this.errors["button"] = [];
        this.errors["button"].push([{ textError: false, linkError: false, linkFormatError: false }])
        this.post.template.settings.button = [];
        this.post.template.settings.button.push([{ type: 'webApp', text: '', link: '' }]);
      }
    },
    addButton(rowIndex) {
      if (this?.buttons[rowIndex]?.length) {
        this.errors["button"][rowIndex].push({ textError: false, linkError: false, linkFormatError: false })
        this.post.template.settings.button[rowIndex].push({ type: 'webApp', text: '', link: '' })
      } else {
        this.errors["button"][rowIndex] = [];
        this.errors["button"][rowIndex].push({ textError: false, linkError: false, linkFormatError: false })
        this.post.template.settings.button[rowIndex] = [];
        this.post.template.settings.button[rowIndex].push({ type: 'webApp', text: '', link: '' });
      }
    },
    delButtonRow(index) {
      this.post.template.settings.button.splice(index, 1);
    },
    delButton(rowIndex, rowBtnIndex) {
      this.post.template.settings.button[rowIndex].splice(rowBtnIndex, 1);
    },
    changeBtnType(payload, btnIndex, rowIndex) {
      if (payload) {
        this.buttons[rowIndex][btnIndex].type = "webApp"
      }
      else {
        this.buttons[rowIndex][btnIndex].type = "web"
      }
    },
    delError(key) {
      delete this.errors[key]
    },
    goBack() {
      this.$router.back()
    },
    delImage(index) {
      this.post.template.settings.images.splice(index, 1)
    },
    moveImage(index, target) {
      let n = index + target;
      if (n > -1 && n < this.post.template.settings.images.length) {
        [this.post.template.settings.images[index], this.post.template.settings.images[n]] = [
          this.post.template.settings.images[n],
          this.post.template.settings.images[index]
        ]
      }
    },
    openFileManager() {
      window.$('#file-manager').modal('show');
      this.$store.commit('onFileSelect', this.select)
    },
    // openSizeFileManager() {
    //   window.$('#file-manager').modal('show');
    //   this.$store.commit('onFileSelect', this.selectSizeTable)
    // },
    select() {
      // const base = this.$store.getters['fm/settings/baseUrl'];
      this.post.template.settings.images = this.$store.getters['fm/selectedItems'].map(i => encodeURI('/storage/' + i.path)).map(
        i => { return { url: i } });
      this.post.template.settings.images = this.post.template.settings.images.slice(0, 1);
    },
    async getTelegramInfo() {
      try {
        const response = await api.get('/api/telegram/info');
        const data = response.data;

        if (data && data.error === undefined) {
          this.tgInfo = data;
        }
      } catch (error) {
        console.error("Error fetching Telegram info:", error);
      }
    },
    handleBtnErrorReset(type, btnRowIndex, btnIndex) {
      switch (type) {
        case "text": {
          this.errors['button'][btnRowIndex][btnIndex].textError = false;
          break;
        }
        case "link": {
          this.errors['button'][btnRowIndex][btnIndex].linkError = false;
          this.errors['button'][btnRowIndex][btnIndex].linkFormatError = false;
          break;
        }
      }
    },

    checkButtonErrors() {
      this.noButtonErrors = true;
      // Инициализируем массив `errors['button']` с той же структурой, что и `this.post.template.settings.button`
      this.errors['button'] = this.post.template.settings.button.map(subArray =>
        subArray.map(button => ({}))
      );
      // Проходим по каждому подмассиву и объекту внутри `this.post.template.settings.button`
      this.post.template.settings.button.forEach((subArray, subIndex) => {
        subArray.forEach((button, buttonIndex) => {
          // Проверяем поле `text`
          if (!button.text || button.text.length === 0) {
            this.errors['button'][subIndex][buttonIndex].textError = true;
            this.noButtonErrors = false;
          }

          // Проверяем поле `link` на налияие текста
          if (!button.link || button.link.length === 0) {
            this.errors['button'][subIndex][buttonIndex].linkError = true;
            this.noButtonErrors = false;
          }

          // Проверяем поле `link` на валидность ссылки
          if (button.link && button.link.length > 0) {
            const urlPattern = new RegExp(
              '^(https?:\\/\\/)' + // Протокол (http или https) — обязателен
              '(([a-zA-Z\\d-]+\\.)+[a-zA-Z]{2,}|' + // Доменное имя должно включать хотя бы одну точку и домен верхнего уровня
              'localhost|' + // Локальный хост
              '((\\d{1,3}\\.){3}\\d{1,3}))' + // Или IP-адрес (v4)
              '(\\:\\d+)?' + // Необязательный порт
              '(\\/[-a-zA-Z\\d%@_.~+&:]*)*' + // Путь
              '(\\?[;&a-zA-Z\\d%@_.,~+&:=-]*)?' + // Параметры
              '(\\#[-a-zA-Z\\d_]*)?$', // Хэш (якорь)
              'i'
            );

            if (!urlPattern.test(button.link)) {
              this.errors['button'][subIndex][buttonIndex].linkFormatError = true;
              this.noButtonErrors = false;
            }
          }
        });
      });
      return this.noButtonErrors;
    },

    validate() {
      if (this.post.name.length === 0) {
        this.errors.name = [this.$static('multisend.name-require-error', 'Ім\'я обов\'язкове')];
        return false
      }
      let imgConfirm = this.post.template.settings.images && this.post.template.settings.images.length > 0
      let srcLength = this.post.template.src.length;
      if (!imgConfirm && srcLength === 0) {
        this.errors.template = [this.$static('multisend.src-require', 'Текст або зображення обов\'язкове')];
        return false
      }
      if (imgConfirm && srcLength >= 1023) {
        this.errors.template = [this.$static('multisend.src-length', 'Максимальная довжина повідомлення 1024 символа')];
        return false
      }

      if (srcLength >= 4096) {
        this.errors.template = [this.$static('multisend.src-length2', 'Максимальная довжина повідомлення 4095 символів')];
        return false
      }

      if (!this.post.timestamp) {
        this.$notify({
          title: this.$static('notify.error-title', 'Помилка'),
          text: this.$static('multisend.date-error', 'Оберіть дату та час відправки'),
          type: 'error',
          duration: 3000
        });
        this.errors.noTime = true
        setTimeout(() => { this.errors.noTime = false }, 2000)
        return false
      }

      // Проверяем кнопки в каждом ряду
      if (!this.checkButtonErrors()) {
        return false
      }
      if (!this.isTestMessageSent) {
        this.$notify({
          title: this.$static('notify.error-title', 'Помилка'),
          text: this.$static('multisend.test-message-sent-error', 'Перед збереженням розсилки потрібно надіслати тестове повідомлення!'),
          type: 'error',
          duration: 3000
        });
        return false;
      }

      return true
    },
    async save() {
      this.isTestMessageSent = true; // чтоб прошла валидация для отправки тестового сообщения

      let valid = this.validate();
      if (!valid) {
        if (this.noButtonErrors) {
          window.scrollTo(0, 0);
        }
        return
      }

      await this.selfCheck();
      if (!this.isTestMessageSent) { return }

      let obj = Object.assign({ info: { ready: 0, send: 0 } }, this.post, {
        timestamp: (this.post.timestamp.getTime() / 1000) | 0,
        info: Object.assign(this.post.info, {
          total: this.tgInfo.count
        })
      });
      // console.log(obj)
      if (obj.info.ready === 0 && this.saveID) {
        obj.save_id = this.saveID;
      }
      // return;
      if (obj.template && obj.template.src) {
        let src = obj.template.src;
        src = src.replace(/<p>/g, '');
        src = src.replace(/<\/p>/g, '\n');
        obj.template.html = src
      }
      // console.log(obj)
      let isLimitError = false;
      try {
        const resp = await api.put('/api/multisend', obj);

        if (resp.status === 200 && resp.data.error === "out of quota") {
          isLimitError = true;
          throw new Error();
        }

        const data = resp.data;
        data.timestamp = new Date(data.timestamp * 1000);
        this.post = Object.assign(this.post, data);
        this.$router.push({ name: 'Multisend' });
        this.$notify({
          title: this.$static('multisend.multisend-title', 'Розсилка'),
          text: this.$static('multisend.save', 'Розсилку збережено.'),
          duration: 3000
        });
      } catch (error) {
        this.$router.push({ name: 'Multisend' });

        this.$notify({
          title: this.$static('notify.error-title', 'Помилка'),
          text: isLimitError ? this.$static('multisend.limit-error', 'Досягнуто максимальну кількість створених розсилок.') : this.$static('notify.error', 'Помилка при збереженні данних'),
          type: 'error',
          duration: 3000
        });
      }
    },

    async selfCheck() {
      this.isTestMessageSent = false;
      try {
        let obj = Object.assign(
          { info: { ready: 0, send: 0 } },
          this.post,
          {
            timestamp: (this.post.timestamp.getTime() / 1000) | 0,
            info: {
              total: this.tgInfo.count,
            },
          }
        );

        if (obj.template && obj.template.src) {
          let src = obj.template.src;
          src = src.replace(/<p>/g, '');
          src = src.replace(/<\/p>/g, '\n');
          obj.template.html = src;
        }

        // Отправка запроса
        const response = await api.post('/api/multisend/self', obj);
        const data = response.data;

        let error;
        if (data.error) {
          error = data.error;
        }
        if (data[0] && data[0].description) {
          error = data[0];
        }

        if (error) {
          this.isTestMessageSent = false;
          if (error.description) {
            this.$notify({
              title: this.$static('notify.error-title', 'Помилка'),
              type: 'error',
              text: error.description,
              duration: 3000,
            });
            return;
          } else {
            switch (error) {
              case 'owner id not define':
                this.$notify({
                  title: this.$static('notify.error-title', 'Помилка'),
                  type: 'error',
                  text: this.$static('multisend.owner-id-error', 'Необхідно вказати Owner id в налаштуваннях'),
                  duration: 3000,
                });
                break;
              case 'template not found':
                this.$notify({
                  title: this.$static('notify.error-title', 'Помилка'),
                  type: 'error',
                  text: this.$static('multisend.template-error', 'Помилка в данних, що відправляються на сервер'),
                  duration: 3000,
                });
                break;
            }
            return;
          }
        }
        this.isTestMessageSent = true;
        this.$notify({
          title: this.$static('multisend.test-message-title', 'Тестове повідомлення'),
          text: this.$static('multisend.test-message-send', 'Тестове повідомлення відправлено'),
          duration: 3000,
        });
      } catch (err) {
        console.error('Ошибка в selfCheck:', err);
        this.isTestMessageSent = false;
        this.$notify({
          title: this.$static('notify.error-title', 'Помилка'),
          type: 'error',
          text: this.$static('multisend.error', 'Сталася помилка при виконанні операції'),
          duration: 30000,
        });
      }
    },
    async fetch() {
      if (this.id) {
        try {
          const response = await api.get(`/api/multisend/${this.id}`);
          const data = response.data;

          if (data) {
            data.timestamp = new Date(data.timestamp * 1000);
            this.post = Object.assign(this.post, data);
          }
        } catch (error) {
          console.error("Error fetching data by id:", error);
        }
      }

      if (this.copy) {
        try {
          const response = await api.get(`/api/multisend/${this.copy}`);
          const data = response.data;

          if (data) {
            data.timestamp = new Date(data.timestamp * 1000);
            this.saveID = data['id'];
            delete data['id'];

            data['info']['success'] = 0;
            data['info']['ready'] = 0;

            this.post = Object.assign(this.post, data, { status: 'new' });
          }
        } catch (error) {
          console.error("Error fetching data by copy:", error);
        }
      }
    }
  },
  watch: {
    async id() {
      await this.fetch();
    }
  }
}
</script>

<style scoped>
textarea {
  width: 100%;
  height: 100%;
  background: inherit;
  border: none;
  border-radius: 7px;
  padding: 10px 14px;
  resize: vertical;
  min-height: 200px;
}

.time {
  box-shadow: 0 0 0 0px red;
  transition: box-shadow 200ms cubic-bezier(0.4, 0, 0.2, 1);
}

.no-time-error {
  box-shadow: 0 0 0 2.1px red;
}
</style>